import angular from 'angular';
import insuranceList from './insuranceList';
import scenes from './scenes';

export default angular
  .module('clientInsurance.scenes.insuranceList', [scenes])
  .component('insuranceList', insuranceList).name;
